// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__116iw","imageUploader":"EGiftCard_imageUploader__1Z33n"};